import { combineReducers } from 'redux';
import bargainReducer from './bargains';
import userReducer from './user-reducer';
import adminReducer from './admin-reducer';
import userDataReducer from './user-data-reducer'

export default combineReducers({
    bargainState: bargainReducer,
    userState: userReducer,
    adminState: adminReducer,
    userData: userDataReducer
})